import React from 'react';

const CorvanaLogo = ({ className = '', size = 'default', variant = 'default' }) => {
  // Compact sizes (xs/sm/md) use a tightly-cropped horizontal wordmark so the
  // actual logo art fills the height (the square asset has big transparent
  // vertical padding, which made the header logo look tiny & faint). Large
  // sizes (default/lg) keep the square mark + particle animation for heroes.
  const sizeStyles = {
    xs: { height: '26px' },
    sm: { height: '34px' },
    md: { height: '44px' },    // Header size — crisp, readable wordmark
    default: { height: '128px' },
    lg: { height: '160px' }
  };
  
  const logoStyle = sizeStyles[size] || sizeStyles.default;
  const isWordmark = size === 'xs' || size === 'sm' || size === 'md';
  // Square logo → CSS width ≈ height; hint the browser the smallest crisp file.
  const sizesHint = { xs: '32px', sm: '48px', md: '56px', default: '128px', lg: '160px' }[size] || '128px';

  // Responsive heights for the compact wordmark so it scales down on phones.
  const wordmarkHeightClass = {
    xs: 'h-6',
    sm: 'h-7 sm:h-8',
    md: 'h-9 sm:h-11 md:h-12',
  }[size] || 'h-9';

  // Light variant for backgrounds where the mark needs to read white. A layered
  // drop-shadow gives the white letters a soft dark outline so they stay legible
  // even on light/white headers.
  const filterStyle = variant === 'light'
    ? { filter: 'brightness(0) invert(1) drop-shadow(0 1px 2px rgba(2,6,23,0.55)) drop-shadow(0 0 1px rgba(2,6,23,0.65))' }
    : {};
  
  return (
    <div className={`relative inline-block ${className}`}>
      {/* Animated particles behind logo - only show on default size */}
      {size === 'default' && (
        <div className="absolute inset-0 pointer-events-none">
          <div className="particle-dust particle-1"></div>
          <div className="particle-dust particle-2"></div>
          <div className="particle-dust particle-3"></div>
          <div className="particle-dust particle-4"></div>
          <div className="particle-dust particle-5"></div>
          <div className="particle-dust particle-6"></div>
          <div className="particle-dust particle-7"></div>
          <div className="particle-dust particle-8"></div>
          <div className="particle-dust particle-9"></div>
          <div className="particle-dust particle-10"></div>
          <div className="particle-dust particle-11"></div>
          <div className="particle-dust particle-12"></div>
          <div className="particle-dust particle-13"></div>
          <div className="particle-dust particle-14"></div>
          <div className="particle-dust particle-15"></div>
        </div>
      )}
      
      {/* Logo — compact placements use the cropped wordmark (fills the height,
          stays crisp); hero placements use the square mark with particles. */}
      {isWordmark ? (
        <img
          src="/corvana-logo-wordmark.webp"
          alt="Corvana"
          width="875"
          height="337"
          decoding="async"
          className={`relative z-10 object-contain w-auto ${wordmarkHeightClass}`}
          style={{ filter: 'drop-shadow(0 1px 2px rgba(2,6,23,0.28)) drop-shadow(0 0 1px rgba(2,6,23,0.22))' }}
        />
      ) : (
        <img 
          src="/corvana-logo-320.webp"
          srcSet="/corvana-logo-128.webp 128w, /corvana-logo-160.webp 160w, /corvana-logo-240.webp 240w, /corvana-logo-320.webp 320w"
          sizes={sizesHint}
          alt="Corvana"
          width="320"
          height="320"
          decoding="async"
          className="relative z-10 object-contain w-auto"
          style={{ ...logoStyle, ...filterStyle }}
        />
      )}
    </div>
  );
};

export default CorvanaLogo;
